import { useQuery } from "@tanstack/react-query";
import { fetch3 } from "../commonApis/commonApis";

const url = process.env.REACT_APP_BASE_URL;

export const useFetchActivityLogs = (params: {
  page: number;
  limit: number;
  userType?: string[];
  modules?: string[];
  warehouseIds?: string[];
  from?: string;
  to?: string;
}) => {
  const { page, limit, userType, modules, warehouseIds, from, to } = params;
  const queryParams = new URLSearchParams({
    page: page.toString(),
    limit: limit.toString(),
  });

  if (userType && userType.length > 0)
    queryParams.append("userType", userType.join(","));
  if (modules && modules.length > 0)
    queryParams.append("modules", modules.join(","));
  if (warehouseIds && warehouseIds.length > 0)
    queryParams.append("warehouseIds", warehouseIds.join(","));
  if (from && to) {
    queryParams.append("from", from);
    queryParams.append("to", to);
  }

  return useQuery({
    queryKey: [
      "activityLogs",
      page,
      limit,
      userType,
      modules,
      warehouseIds,
      from,
      to,
    ],
    queryFn: async () => {
      const res = await fetch3(
        `${url}/api/activity-logs?${queryParams.toString()}`,
        "GET"
      );
      if (!res || !res.data) {
        throw new Error(res.message || "Failed to fetch activity logs");
      }
      return res.data;
    },
    staleTime: 5 * 60 * 1000,
  });
};

export const useFetchActivityLogFilters = () => {
  return useQuery({
    queryKey: ["activityLogsFilters"],
    queryFn: async () => {
      const res = await fetch3(`${url}/api/activity-logs/filters`, "GET");
      if (!res || !res.data)
        throw new Error(res.message || "Failed to fetch filters");
      return res.data;
    },
    staleTime: 10 * 60 * 1000,
  });
};
